import api from './api.service';

function upload(params) {
  return api.post('/files', params);
}

function download(fileId, params) {
  return api.get(`/files/${fileId}/download`, params);
}

export const filesService = {
    upload,
    download,
};
